import { ExpressionRule } from "../../ExpressionRule";
import { ExpressionValue } from "../../ExpressionValue";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class StringLengthExpression extends ExpressionRule {
    readonly __type: string = "String Length";
    readonly __ruleName: string = "Length";
    value1: ExpressionValue;

    constructor() {
        super();
        this.value1 = ExpressionValue.createExpressionValue(this, "stringValue", new StringDataDefinition());
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return this.value1.evaluate(data, testContext).length;
    }
}
